import React from 'react';
import popup from "~/views/Popup/popup";

const VideoWrapper = (props) => {
    const contents = {
        login : <div className="login-prompt">
                    <p>Please login to watch this video</p>
                    <button className="login-button" 
                            onClick={()=>popup.fitnessSignInCreate({showCloseButton: false})}
                    >Login</button>
                </div>,
        timer : <div className="login-prompt">
                    {props.renderLiveTimePrompt && props.renderLiveTimePrompt(props.gist.scheduleStartDate, props.gist.scheduleEndDate)}
                </div>,
        liveDone : <div className="login-prompt">
                    <p>Event has finished</p>
                </div>
    }
    return <div className="video-wrapper">
        <div className="video-thumbnail" style={{ backgroundImage: `url(${props.gist.imageGist["_16x9"]})` }}>
        { 
            props.user !== '' && contents[props.type]
        }
        </div>
    </div>
}

export default VideoWrapper;